import { useEffect, useState } from 'react'
import axios from 'axios'
import { mergeLandingContent } from '../config/landingDefaults'

let cache = null
let cachePromise = null

const FALLBACK_CMS = mergeLandingContent(null)

export function useCmsLanding() {
  const [cms, setCms] = useState(cache || FALLBACK_CMS)
  const [loading, setLoading] = useState(!cache)

  useEffect(() => {
    if (cache) {
      setCms(cache)
      setLoading(false)
      return undefined
    }
    if (!cachePromise) {
      cachePromise = axios
        .get('/api/cms/landing')
        .then((res) => {
          cache = mergeLandingContent(res.data)
          return cache
        })
        .catch(() => {
          cache = FALLBACK_CMS
          return cache
        })
    }
    cachePromise
      .then((data) => {
        setCms(data)
        setLoading(false)
      })
      .catch(() => {
        setCms(FALLBACK_CMS)
        setLoading(false)
      })
    return undefined
  }, [])

  return { cms, loading }
}

export function authMarketingFeatures(cms, panel = 'login') {
  return cms?.authMarketing?.[panel]?.features || []
}
